import { Link } from "react-router-dom";

const footerLinks = {
  main: [
    { name: "Programs", href: "/programs" },
    { name: "Trainers", href: "/trainers" },
    { name: "Nutrition", href: "/nutrition" },
    { name: "Park Classes", href: "/park-classes" },
  ],
  company: [
    { name: "About", href: "/about" },
    { name: "Pricing", href: "/pricing" },
    { name: "FAQ", href: "/faq" },
    { name: "Contact", href: "/contact" },
  ],
  legal: [
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms of Service", href: "/terms" },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      role="contentinfo"
      className="mt-16 border-t border-blue-100 bg-white/90 text-sm text-gray-600"
    >
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <h2 className="text-xs uppercase tracking-[0.35em] text-blue-600 font-semibold mb-3">
              FitEasy
            </h2>
            <p className="max-w-md text-sm text-gray-700 leading-relaxed">
              Your comprehensive fitness platform delivering personalized
              workouts, nutrition plans, and expert guidance to help you reach
              your health and wellness goals.
            </p>
            <p className="mt-4 text-xs text-gray-500">
              © {currentYear} FitEasy. All rights reserved.
            </p>
          </div>

          {/* Main Links */}
          <nav aria-label="Main navigation">
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-900 mb-3">
              Services
            </h3>
            <ul className="space-y-2" role="list">
              {footerLinks.main.map((link) => (
                <li key={link.name} role="listitem">
                  <Link
                    to={link.href}
                    className="text-sm text-gray-600 hover:text-blue-600 transition focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 rounded"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Company Links */}
          <nav aria-label="Company navigation">
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-900 mb-3">
              Company
            </h3>
            <ul className="space-y-2" role="list">
              {footerLinks.company.map((link) => (
                <li key={link.name} role="listitem">
                  <Link
                    to={link.href}
                    className="text-sm text-gray-600 hover:text-blue-600 transition focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 rounded"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-4">
              <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-gray-900 mb-3">
                Legal
              </h3>
              <ul className="space-y-2" role="list">
                {footerLinks.legal.map((link) => (
                  <li key={link.name} role="listitem">
                    <Link
                      to={link.href}
                      className="text-sm text-gray-600 hover:text-blue-600 transition focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 rounded"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </footer>
  );
}


